import { useStaticQuery, graphql } from 'gatsby'

export const useTestimonialsQuery = () => {
  const { wpPage, forRatingValuePart1, forRatingValuePart2, reviews } = useStaticQuery(graphql`
    query TestimonialsQuery {
      wpPage(title: { eq: "Home" }) {
        testimonials {
          testimonials {
            backgroundImageMobile {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, quality: 100, formats: [WEBP])
                }
              }
            }
            backgroundImageDesktop {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, quality: 100, formats: [WEBP])
                }
              }
            }
            title
            playButton {
              localFile {
                publicURL
              }
            }
            testimonials {
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: WEBP, sizes: "(min-width: 1024px) 36vw, 92vw")
                  }
                }
              }
              altText
              videoUrl {
                url
              }
              testimonialText
            }

            title2
            reviewWidgetText
            reviewIcons {
              googleIcon {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      formats: WEBP
                      sizes: "(min-width: 1024px) 4vw, 11vw"
                      quality: 100
                    )
                  }
                }
              }
              facebookIcon {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      formats: WEBP
                      sizes: "(min-width: 1024px) 4vw, 11vw"
                      quality: 100
                    )
                  }
                }
              }
              localreviewsIcon {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      formats: WEBP
                      sizes: "(min-width: 1024px) 4vw, 11vw"
                      quality: 100
                    )
                  }
                }
              }
            }
            link {
              title
              url
            }
          }
        }
      }
      forRatingValuePart1: allBirdeyedata(
        filter: { id: { ne: "dummy" }, sourceType: { ne: "Direct Feedback" } }
      ) {
        nodes {
          rating
        }
      }
      forRatingValuePart2: allBirdeyedata(filter: { id: { ne: "dummy" }, rating: { ne: 0 } }) {
        nodes {
          rating
        }
      }
      reviews: allBirdeyedata(
        limit: 6
        filter: {
          rating: { eq: 5 }
          comments: { ne: null }
          reviewer: { lastName: { ne: "HTEAM345" } }
        }
      ) {
        nodes {
          comments
          reviewer {
            firstName
            lastName
          }
          sourceType
          rating
        }
      }
    }
  `)
  return { wpPage, forRatingValuePart1, forRatingValuePart2, reviews }
}
